import { render, staticRenderFns } from "./CodeView.vue?vue&type=template&id=57504aa5&scoped=true"
import script from "./CodeView.vue?vue&type=script&lang=js"
export * from "./CodeView.vue?vue&type=script&lang=js"
import style0 from "./CodeView.vue?vue&type=style&index=0&id=57504aa5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57504aa5",
  null
  
)

export default component.exports